var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8666 2.99999L22.3926 19.5C22.4804 19.652 22.5266 19.8244 22.5266 20C22.5266 20.1755 22.4804 20.348 22.3926 20.5C22.3048 20.652 22.1786 20.7782 22.0266 20.866C21.8746 20.9538 21.7021 21 21.5266 21H2.47458C2.29905 21 2.12661 20.9538 1.97459 20.866C1.82258 20.7782 1.69634 20.652 1.60858 20.5C1.52081 20.348 1.47461 20.1755 1.47461 20C1.47461 19.8244 1.52082 19.652 1.60858 19.5L11.1346 2.99999C11.2224 2.84798 11.3486 2.72175 11.5006 2.63399C11.6526 2.54623 11.8251 2.50003 12.0006 2.50003C12.1761 2.50003 12.3485 2.54623 12.5006 2.63399C12.6526 2.72175 12.7788 2.84798 12.8666 2.99999ZM4.20658 19H19.7946L12.0006 5.49999L4.20658 19ZM11.0006 16H13.0006V18H11.0006V16ZM11.0006 8.99999H13.0006V14H11.0006V8.99999Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertLine);
export default __webpack_public_path__ + "static/media/alert-line.0a973a927352387f09acf455c372f1c6.svg";
export { ForwardRef as ReactComponent };